import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('document', '/documents')
const actions = generator.generate()

export default actions
